import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { initializeAnalytics } from '../../utils/analytics/analytics';
import { trackQueuedOptimoveEvents, initOptimoveUser } from '../../../utils/analytics/implementations/google_tag_manager';

function CommonLogicComponent({
  initialOrder, userId, identifyUser
}) {
  useEffect(() => {
    initialOrder();
    initializeAnalytics();
    if (window.optimoveSDK) {
      trackQueuedOptimoveEvents();
      initOptimoveUser(userId);
    }
    const handleOptimoveReady = () => {
      trackQueuedOptimoveEvents();
      initOptimoveUser(userId);
    };

    window.addEventListener('optimoveReady', handleOptimoveReady);
    return () => {
      window.removeEventListener('optimoveReady', handleOptimoveReady);
    };
  }, []);

  useEffect(() => {
    if (userId) {
      identifyUser();
      if (window.optimoveSDK?.API) initOptimoveUser(userId);
    }
  }, [userId]);

  return <></>;
}

CommonLogicComponent.propTypes = {
  initialOrder: PropTypes.func.isRequired,
  userId: PropTypes.number,
  identifyUser: PropTypes.func.isRequired
};

CommonLogicComponent.defaultProps = {
  userId: null
};

export default CommonLogicComponent;
